import { ChangeType } from '@zapier/design-system-revenue/src/types';
import { getChangeLabel } from '../getChangeLabel';

export const getChangeLabelForPlanName = (
  changeType: ChangeType,
  planName: string
): string => {
  const changeLabel = getChangeLabel(changeType);

  if (changeType === 'change') {
    return `${changeLabel} Billing for ${planName} Plan`;
  }

  return `${changeLabel} to ${planName} Plan`;
};
